export default {
  
  user: {
    login: '/login',
  },
  station: {
    list: '/backend/station',
    save: '/backend/station',
  }
}